import { produce } from 'immer';
import { GET_BANK_CHOICE_CHIPS } from '../types/bank';

const initialState = {
    bankChoiceChips: null
}

const reducer = produce((state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_BANK_CHOICE_CHIPS:
            state.bankChoiceChips = payload;
            return;
        default:
            return state;
    }
})

export default reducer;